import type { SensitivityDeclineModel } from './sensitivityModelCalculations';

export interface UncertaintySettings {
  selectedModel: SensitivityDeclineModel;
  forecastYears: string;
  simulations: string;
  productivityPct: string;
  declinePct: string;
  engineeringPct: string;
  terminalDeclinePct: string;
  seed: number;
}

export const defaultUncertaintySettings: UncertaintySettings = {
  selectedModel: 'exponential',
  forecastYears: '5',
  simulations: '1000',
  productivityPct: '15',
  declinePct: '20',
  engineeringPct: '10',
  terminalDeclinePct: '5',
  seed: 20260919,
};

export function loadUncertaintySettings(projectId: number): UncertaintySettings {
  try {
    const saved = localStorage.getItem(`production_forecast_uncertainty_${projectId}`);
    return saved ? { ...defaultUncertaintySettings, ...JSON.parse(saved) } : defaultUncertaintySettings;
  } catch {
    return defaultUncertaintySettings;
  }
}

export function saveUncertaintySettings(projectId: number, settings: UncertaintySettings) {
  try {
    localStorage.setItem(`production_forecast_uncertainty_${projectId}`, JSON.stringify(settings));
  } catch {
    // localStorage不可用时不影响页面运行
  }
}